class AllActionTypes {
    //for loader
    static LOADER_STATE_TRUE = 'LOADER_STATE_TRUE';
    static LOADER_STATE_FALSE = 'LOADER_STATE_FALSE';
    static HANDLE_LEFT = 'HANDLE_LEFT';
    static ACTIVE_LINK = 'ACTIVE_LINK';
    static CLEAR_DATA = 'CLEAR_DATA';
    static ROLE_PERMISSION = 'ROLE_PERMISSION';
    static CONNECT_DISCONNECT_TO_WEBSOCKET = 'CONNECT_DISCONNECT_TO_WEBSOCKET';
    static LOCK_FLAG = 'LOCK_FLAG';
    static PLANNING_EDITABLE_BEFORE_CURRENT_DAY = 'PLANNING_EDITABLE_BEFORE_CURRENT_DAY';
    static DOCTOR_CREATION = 'DOCTOR_CREATION';
    static QUOTATION_ACCEPT_ID = 'QUOTATION_ACCEPT_ID';
    static QUOTATION_ACCEPT_FLAG = 'QUOTATION_ACCEPT_FLAG';
    static SKIP_BUSINESS_DAY_OVERRIDE_WARNING = 'SKIP_BUSINESS_DAY_OVERRIDE_WARNING';
    static LOCAL_TIMEZONE = 'LOCAL_TIMEZONE';
}
export default AllActionTypes;